import { PERMISSIONS } from '~/constants/permissions.constants';

export const getAllowedDepartments = (user, permissions) => {
  if (!user || !permissions) return [];

  const permissionsList = [
    {
      key: PERMISSIONS.checklist.columns.legalization,
      department: "1",
    },
    {
      key: PERMISSIONS.checklist.columns.administrative,
      department: "2",
    },
    {
      key: PERMISSIONS.checklist.columns.accounting,
      department: "3",
    },
    {
      key: PERMISSIONS.checklist.columns.fiscal,
      department: "4",
    },
    {
      key: PERMISSIONS.checklist.columns.personal,
      department: "5",
    },
    {
      key: PERMISSIONS.checklist.columns.cs,
      department: "6",
    },
  ];

  let userPermissions = [];

  if (!user.permissions_group_id) {
    userPermissions = user.permissions;
  } else {
    const permissionsGroup = (userPermissions = permissions.find(
      (item) => item.id === user.permissions_group_id
    ));
    if (!permissionsGroup) return [];
    userPermissions = permissionsGroup.permissions;
  }

  return permissionsList
    .filter((item) => userPermissions.includes(item.key))
    .map((item) => item.department);
};

// null = nada a medir (departamento sem tarefa neste checklist, ou fora da
// permissão do usuário). A tela mostra "—", em vez de um 100% verde que
// parecia trabalho feito.
export const getTaskPercentage = (record, department, allowedDepartments) => {
  if (!allowedDepartments.includes(department)) return null;

  const tasks = record.tasks.filter((task) => task.department === department);
  if (tasks.length === 0) return null;
  
  const concludedTasksAmount = tasks.filter((task) => task.done).length;
  const percentage =
    Math.ceil((100 * concludedTasksAmount) / tasks.length) || 0;

  return percentage;
};

export const getTaskTotalPercentage = (record, allowedDepartments) => {
  const allowedTasks = record.tasks.filter((task) =>
    allowedDepartments.includes(task.department)
  );
  const concludedTasksCount = allowedTasks.filter((task) => task.done).length;
  const concludedTasksPercentage = Math.ceil(
    (100 * concludedTasksCount) / allowedTasks.length
  );

  return concludedTasksPercentage;
};

export const getPercentageColor = (percentage) => {
  if (percentage < 30) return "#f5222d";
  else if (percentage < 60) return "#d4b106";
  else if (percentage < 99) return "#2f54eb";
  else return "#389e0d";
};

export const getStatusName = (status) => {
  const names = {
    1: "Encerramento",
    2: "Entrada",
    3: "Troca (Saída)",
    4: "Troca (Entrada)",
  };

  return names[status];
};

// Só cliente que está entrando tem reunião de onboarding: Entrada (2) e
// Troca (Entrada) (4). Saída e encerramento ficam com o campo cinza.
export const hasOnboarding = (status) => [2, 4].includes(status);

export const getStatusStyle = (status) => {
  const colors = { 1: "#f5222d", 2: "#a0d911", 3: "#fa8c16", 4: "#1890ff" };

  return {
    borderColor: colors[status],
    color: colors[status],
  };
};

export const getChecklistStatusName = (status) => {
  return {
    1: "Saída (Encerramento)",
    2: "Entrada",
    3: "Saída (Troca de Contabilidade)",
    4: "Entrada (Troca de Contabilidade)",
  }[status];
}
// Busca da lista: nome ou código do cliente, sem acento e sem caixa.
export const normalizeSearch = (text) =>
  (text || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export const matchesChecklistSearch = (item, search) => {
  if (!item.customer) return false;
  const term = normalizeSearch(search);
  if (!term) return true;
  const cod = item.customer.cod ? String(item.customer.cod) : "";
  return normalizeSearch(item.customer.name).includes(term)
    || normalizeSearch(cod).includes(term)
    || normalizeSearch(`${cod} - ${item.customer.name}`).includes(term);
};

// Filtros da tela, mantidos por alguns minutos após o refresh (usePersistedFilters).
export const CHECKLIST_FILTERS_KEY = "checklist";

export const CHECKLIST_STATUSES = ["late", "pending", "concluded"];

export const getDefaultChecklistFilters = () => ({
  activeButton: "late",
  search: "",
});

// Um valor salvo desconhecido derrubaria a tela (checklists[activeButton]).
export const normalizeChecklistFilters = (filters) => {
  const f = filters || {};
  return {
    activeButton: CHECKLIST_STATUSES.indexOf(f.activeButton) >= 0 ? f.activeButton : "late",
    search: typeof f.search === "string" ? f.search : "",
  };
};

// Badge: só o que difere do padrão.
export const countActiveChecklistFilters = (filters, defaults) =>
  (filters.activeButton !== defaults.activeButton ? 1 : 0) + (filters.search ? 1 : 0);
